<template>
  <BaseAutoCompleteWithSingleSelectedItem
    :readonly="readonly"
    :disabled="disabled"
    v-model="localModelValue"
    label="管理会社"
    itemName="name"
    :items="items"
    :errorMessages="props.errorMessages"
    :clearable="props.clearable"
    :selectFirstIfOnlyOne="props.selectFirstIfOnlyOne"
  />
</template>
<script setup lang="ts">
import BaseAutoCompleteWithSingleSelectedItem from '@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue';
import getManagementOffice from '@/types/responses/getManagementOffice';
import { onMounted, ref, computed, withDefaults, watch } from 'vue';
import Api from '@/services/api/ApiServiceFabrick';

const props = withDefaults(
  defineProps<{
  modelValue: getManagementOffice | undefined;
  selectFirstIfOnlyOne?: boolean;
  initialManagementId?: number;
  initialManagementType?: string; // management officeのIDは重複する可能性があるので、typeで絞り込む。
  errorMessages?: string[];
  clearable?: boolean;
  readonly?: boolean;
  disabled?: boolean;
}>(),
{
  disabled: false,
  clearable: true,
})

const emit = defineEmits(['update:modelValue']);

const items = ref<getManagementOffice[]>([]);

onMounted(() => {
  Api()
    .autoCompleteManagementOffices()
    .then((data) => {
      items.value = data;
      setModelValue()
    });
});

watch(
  () => [props.initialManagementId, props.initialManagementType],
  () => {
    setModelValue();
  }
);

const localModelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
})

const setModelValue = () => {
  const filteredItems = items.value;
  if (props.initialManagementId && props.initialManagementType) {
    localModelValue.value = filteredItems.filter((item) => {
      return item.id === props.initialManagementId && item.type === props.initialManagementType
    })[0];
  }
}
</script>
